/*global kakao*/

import React, { Component } from "react";

import queryString from "query-string";

import axios from '@app/lib/axios';

import "./map.css";

import $ from "jquery";

import * as Constant from "../../../Constant.js";

import MapContractCards, { initData as ContractCardsInit } from "./Components/contract/MapContractCards.js";

import KakaoMapContent from "./KakaoMapContent";

import LocaleBranchList from "./Components/contract/LocaleBranchList";
import BranchBizareaInfo from "./Components/contract/BranchBizareaInfo";

import ContractNurseryChart from "./Components/contract/ContractNurseryChart";

import LocaleList from "./Components/contract/LocaleList";
import BranchList from "./Components/contract/BranchList";

const ACC_COLOR_TABLE = ["#FFC3AC", "#A6EADF", "#74E1DE", "#3CD8E1", "#00C7EF"];
const BRANCH_ACC_COLOR_TABLE = ["#A6EADF", "#FFEE9F", "#ffb14b", "#fc4f2a", "#E31B1B"];
const HEIGHT_KAKAO_MAP = 600;
const STROKE_COLOR_MAP_HIGHLIGHTED = "#f95431";
const STROKE_COLOR_MAP_HIGHLIGHTED_BRANCH = "#313a97";
const STROKE_COLOR_MAP = "#004c80";

const BY_ABSOLUTE = "absolute";
const BY_RELATIVE = "relative";
const BY_BRANCH = "branch";

class MapContract extends Component {
    constructor(props) {
        super(props);
        this.state = {
            year: new Date().getFullYear(),
            display_method: BY_ABSOLUTE,
            tomonote: true,
            tomobooks: false,
            data: null,
            map: null,
            gis_data: null,
            branch_infos: null,
            loc_infos: null,
            showInfo: false,
            polygonClicked: false,
            title: null,
            total: null,
            content: null,
            selected_loc: null,
            selected_branch: null,
            selected_for_graph: null,
            is_branch_select: false,
            polygons: [],
            localeNameOverlays: [],
            selected_polygon: null,
            selected_polygon_color: null,
            country_total: null,
            stroke_color: STROKE_COLOR_MAP_HIGHLIGHTED,
        };
    }

    onKakaoScriptLoadEndHandler() {
        this.initKakaoMap();

        fetch("/assets/82.json")
            .then((response) => response.json())
            .then((geojson) => {
                this.state.gis_data = geojson.features;
                this.getContractData();
            })
            .catch((error) => {
                console.log(error);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            });
    }

    getContractData() {
        axios({
            method: "get",
            url: Constant.API_DOMAIN + "/api/map/contract",
        })
            .then((result) => {
                if (result.data.code === 200) {
                    this.extractContractData(result.data);
                } else {
                    console.log(result);
                    console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
                }
            })
            .catch((error) => {
                console.log(error);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            });
    }

    extractContractData(data) {
        if (data.branches) {
            var branch_infos = [];
            var loc_infos = data.loc_infos;

            data.branches.forEach((biza) => {
                var b = branch_infos.find((b) => b.ID == biza.ID);
                // 지사 목록 추가
                if (!b) {
                    b = {
                        ID: biza.ID,
                        NAME: biza.NAME,
                        TYPE: biza.TYPE,
                        CONTRACT_YEAR: biza.CONTRACT_YEAR,
                        LOC_CODE: biza.LOC_CODE,
                        is_biz_all: false,
                        // 영업 지역, 연도별 계약 정보,
                        biz_area: [],
                        bizs: [],
                    };
                    branch_infos.push(b);
                }

                // 지사 영업지역 추가
                b.biz_area.push({ LOC_CODE: biza.LOC_CODE, is_biz_area: true, branch: b, contract: null });
                if (biza.LOC_CODE == 0) b.is_biz_all = true;
            });

            // 정렬
            branch_infos.sort(function (a, b) {
                if (a.TYPE > b.TYPE) return -1;
                if (a.TYPE < b.TYPE) return 1;
                if (a.NAME < b.NAME) return -1;
                if (a.NAME > b.NAME) return 1;
                return 0;
            });

            this.state.gis_data.forEach((sigungu) => {
                var loc_info = loc_infos.find((loc_code) => loc_code.CODE == sigungu.properties.SIG_CD);

                if (loc_info) {
                    loc_info.bizs = [];
                    loc_info["contract"] = {};
                    for (var year = 2017; year <= parseInt(this.state.year); year++) {
                        loc_info.contract[year] = {
                            BRANCH: 0,
                            TOTAL: 0,
                            RATE_SHARE: 0,
                            RATE_LOCALE: 0,
                            RATE_RENEW: 0,
                            RATE_RENEW_GROWTH: 0,
                            RATE_GROWTH: 0,
                            TOTAL_NEW: 0,
                            TOTAL_RENEW: 0,
                            NURSERY_NEW: 0,
                            NURSERY_RENEW: 0,
                            NURSERY_T_NEW: 0,
                            NURSERY_T_RENEW: 0,
                            DAYCARE_NEW: 0,
                            DAYCARE_RENEW: 0,
                            DAYCARE_T_NEW: 0,
                            DAYCARE_T_RENEW: 0,
                            NULL_NEW: 0,
                            NULL_RENEW: 0,
                            NULL_T_NEW: 0,
                            NULL_T_RENEW: 0,
                            NURSERY_NURSERY: 0,
                            NURSERY_DAYCARE: 0,
                            NURSERY_NULL: 0,
                        };
                    }

                    loc_info.gis_data = sigungu;
                    // 해당 지역 지사별 계약 정보 추출
                    var contracts = data.contracts.filter((n) => n.loc_code == loc_info.CODE);

                    if (contracts.length > 0) {
                        // 검색된 해당 지역 계약을 전체 목록에서 삭제
                        for (var i = data.contracts.length - 1; i > -1; i--) {
                            if (data.contracts[i].loc_code == loc_info.CODE) {
                                data.contracts.splice(i, 1);
                            }
                        }

                        // 해당 지역 계약 지사 리스트 추출
                        var branches = branch_infos.filter((b) => contracts.some((c) => b.ID == c.id));

                        for (var i = branches.length - 1; i > -1; i--) {
                            var biz_area_info = branches[i].biz_area.find(
                                (biz) =>
                                    biz.LOC_CODE === 0 || biz.LOC_CODE === loc_info.CODE || biz.LOC_CODE === Math.floor(loc_info.CODE / 1000) || biz.LOC_CODE === loc_info.CODE - (loc_info.CODE % 10)
                            );

                            var is_biz_area = biz_area_info !== undefined;
                            var biz = { LOC_CODE: loc_info.CODE, is_biz_area: is_biz_area, branch: branches[i] };

                            biz["contract"] = {};
                            for (var year = 2017; year <= parseInt(this.state.year); year++) {
                                biz.contract[year] = {
                                    TOTAL: 0,
                                    RATE_SHARE: 0,
                                    RATE_RENEW: 0,
                                    RATE_RENEW_GROWTH: 0,
                                    RATE_GROWTH: 0,
                                    TOTAL_NEW: 0,
                                    TOTAL_RENEW: 0,
                                    // 신규 계약, 재계약, 신규 해지, 재계약 해지
                                    NURSERY_NEW: 0,
                                    NURSERY_RENEW: 0,
                                    NURSERY_T_NEW: 0,
                                    NURSERY_T_RENEW: 0,
                                    DAYCARE_NEW: 0,
                                    DAYCARE_RENEW: 0,
                                    DAYCARE_T_NEW: 0,
                                    DAYCARE_T_RENEW: 0,
                                    NULL_NEW: 0,
                                    NULL_RENEW: 0,
                                    NULL_T_NEW: 0,
                                    NULL_T_RENEW: 0,
                                    // 원 개수
                                    NURSERY_NURSERY: 0,
                                    NURSERY_DAYCARE: 0,
                                    NURSERY_NULL: 0,
                                };
                            }

                            for (var j = contracts.length - 1; j > -1; j--) {
                                if (contracts[j].id == branches[i].ID) {
                                    var contract = contracts[j];
                                    contracts.splice(j, 1);
                                    // 연도별 지사 지역 계약 정보
                                    for (var year = 2017; year <= parseInt(this.state.year); year++) {
                                        if (contract.type == "K") {
                                            biz.contract[year].NURSERY_NEW += contract["n_" + year];
                                            biz.contract[year].NURSERY_RENEW += contract["rn_" + year];
                                            biz.contract[year].NURSERY_T_NEW += contract["t_" + year];
                                            biz.contract[year].NURSERY_T_RENEW += contract["renew_t_" + year];
                                            biz.contract[year].TOTAL += contract["n_" + year];
                                            biz.contract[year].TOTAL += contract["rn_" + year];
                                            loc_info.contract[year].NURSERY_NEW += contract["n_" + year];
                                            loc_info.contract[year].NURSERY_RENEW += contract["rn_" + year];
                                            loc_info.contract[year].NURSERY_T_NEW += contract["t_" + year];
                                            loc_info.contract[year].NURSERY_T_RENEW += contract["renew_t_" + year];
                                            loc_info.contract[year].TOTAL += contract["n_" + year];
                                            loc_info.contract[year].TOTAL += contract["rn_" + year];

                                            if (biz.contract[year].NURSERY_NEW > 0 || biz.contract[year].NURSERY_RENEW) {
                                                biz.contract[year].NURSERY_NURSERY++;
                                                loc_info.contract[year].NURSERY_NURSERY++;
                                            }
                                        } else if (contract.type == "D") {
                                            biz.contract[year].DAYCARE_NEW += contract["n_" + year];
                                            biz.contract[year].DAYCARE_RENEW += contract["rn_" + year];
                                            biz.contract[year].DAYCARE_T_NEW += contract["t_" + year];
                                            biz.contract[year].DAYCARE_T_RENEW += contract["renew_t_" + year];
                                            biz.contract[year].TOTAL += contract["n_" + year];
                                            biz.contract[year].TOTAL += contract["rn_" + year];
                                            loc_info.contract[year].DAYCARE_NEW += contract["n_" + year];
                                            loc_info.contract[year].DAYCARE_RENEW += contract["rn_" + year];
                                            loc_info.contract[year].DAYCARE_T_NEW += contract["t_" + year];
                                            loc_info.contract[year].DAYCARE_T_RENEW += contract["renew_t_" + year];
                                            loc_info.contract[year].TOTAL += contract["n_" + year];
                                            loc_info.contract[year].TOTAL += contract["rn_" + year];

                                            if (biz.contract[year].DAYCARE_NEW > 0 || biz.contract[year].DAYCARE_RENEW) {
                                                biz.contract[year].NURSERY_DAYCARE++;
                                                loc_info.contract[year].NURSERY_DAYCARE++;
                                            }
                                        } else {
                                            biz.contract[year].NULL_NEW += contract["n_" + year];
                                            biz.contract[year].NULL_RENEW += contract["rn_" + year];
                                            biz.contract[year].NULL_T_NEW += contract["t_" + year];
                                            biz.contract[year].NULL_T_RENEW += contract["renew_t_" + year];
                                            biz.contract[year].TOTAL += contract["n_" + year];
                                            biz.contract[year].TOTAL += contract["rn_" + year];
                                            loc_info.contract[year].NULL_NEW += contract["n_" + year];
                                            loc_info.contract[year].NULL_RENEW += contract["rn_" + year];
                                            loc_info.contract[year].NULL_T_NEW += contract["t_" + year];
                                            loc_info.contract[year].NULL_T_RENEW += contract["renew_t_" + year];
                                            loc_info.contract[year].TOTAL += contract["n_" + year];
                                            loc_info.contract[year].TOTAL += contract["rn_" + year];

                                            if (biz.contract[year].NULL_NEW > 0 || biz.contract[year].NULL_RENEW) {
                                                biz.contract[year].NURSERY_NULL++;
                                                loc_info.contract[year].NURSERY_NULL++;
                                            }
                                        }
                                    }
                                }
                            }

                            branches[i].bizs.push(biz);
                            loc_info.bizs.push(biz);
                        }

                        // 지역별 지사 점유율, 재계약율
                        loc_info.bizs.forEach((biz) => {
                            for (var year = 2017; year <= parseInt(this.state.year); year++) {
                                biz.contract[year].TOTAL_NEW = biz.contract[year].NURSERY_NEW + biz.contract[year].DAYCARE_NEW + biz.contract[year].NULL_NEW;
                                biz.contract[year].TOTAL_RENEW = biz.contract[year].NURSERY_RENEW + biz.contract[year].DAYCARE_RENEW + biz.contract[year].NULL_RENEW;
                                biz.contract[year].RATE_SHARE = loc_info.contract[year].TOTAL > 0 ? Math.ceil((biz.contract[year].TOTAL / loc_info.contract[year].TOTAL) * 100) : 0;
                                if (year > 2017) {
                                    biz.contract[year].RATE_RENEW =
                                        biz.contract[year - 1].TOTAL > 0
                                            ? Math.ceil(((biz.contract[year].NURSERY_RENEW + biz.contract[year].DAYCARE_RENEW + biz.contract[year].NULL_RENEW) / biz.contract[year - 1].TOTAL) * 100)
                                            : 0;
                                    biz.contract[year].RATE_RENEW_GROWTH =
                                        biz.contract[year - 1].TOTAL > 0 ? Math.ceil(((biz.contract[year].TOTAL_RENEW - biz.contract[year - 1].TOTAL) / biz.contract[year - 1].TOTAL) * 100) : 0;
                                    biz.contract[year].RATE_GROWTH =
                                        biz.contract[year - 1].TOTAL > 0 ? Math.ceil(((biz.contract[year].TOTAL - biz.contract[year - 1].TOTAL) / biz.contract[year - 1].TOTAL) * 100) : 0;
                                }
                                if (biz.contract[year].TOTAL > 0) {
                                    loc_info.contract[year].BRANCH++;
                                }
                            }
                        });

                        // 지역별 지사 정렬
                        loc_info.bizs.sort((a, b) => {
                            if (a.is_biz_area > b.is_biz_area) return -1;
                            if (a.is_biz_area < b.is_biz_area) return 1;
                            if (a.contract[this.state.year].TOTAL > b.contract[this.state.year].TOTAL) return -1;
                            if (a.contract[this.state.year].TOTAL < b.contract[this.state.year].TOTAL) return 1;
                            return 0;
                        });
                    }
                }
            });

            // 지사별 영업지역 정렬
            branch_infos.forEach((b) =>
                b.bizs.sort((a, b) => {
                    if (a.is_biz_area > b.is_biz_area) return -1;
                    if (a.is_biz_area < b.is_biz_area) return 1;
                    if (a.contract[this.state.year].TOTAL > b.contract[this.state.year].TOTAL) return -1;
                    if (a.contract[this.state.year].TOTAL < b.contract[this.state.year].TOTAL) return 1;
                    return 0;
                })
            );

            // 지역별 지사 점유율, 재계약율, 재계약 증가율,
            for (var year = 2017; year <= parseInt(this.state.year); year++) {
                var total = 0;
                loc_infos.forEach((loc) => {
                    if (loc.contract) {
                        total += loc.contract[year].TOTAL;
                        loc.contract[year].TOTAL_NEW = loc.contract[year].NURSERY_NEW + loc.contract[year].DAYCARE_NEW + loc.contract[year].NULL_NEW;
                        loc.contract[year].TOTAL_RENEW = loc.contract[year].NURSERY_RENEW + loc.contract[year].DAYCARE_RENEW + loc.contract[year].NULL_RENEW;
                        loc.contract[year].RATE_LOCALE =
                            loc.NURSERY_COUNT + loc.DAYCARE_COUNT > 0
                                ? (
                                      ((loc.contract[year].NURSERY_NURSERY + loc.contract[year].NURSERY_DAYCARE + loc.contract[year].NURSERY_NULL) / (loc.NURSERY_COUNT + loc.DAYCARE_COUNT)) *
                                      100
                                  ).toFixed(2)
                                : -1;
                        if (year > 2017) {
                            loc.contract[year].RATE_RENEW =
                                loc.contract[year - 1].TOTAL > 0
                                    ? (((loc.contract[year].NURSERY_RENEW + loc.contract[year].DAYCARE_RENEW + loc.contract[year].NULL_RENEW) / loc.contract[year - 1].TOTAL) * 100).toFixed(0)
                                    : 0;
                            loc.contract[year].RATE_RENEW_GROWTH =
                                loc.contract[year - 1].TOTAL > 0 ? Math.ceil(((loc.contract[year].TOTAL_RENEW - loc.contract[year - 1].TOTAL) / loc.contract[year - 1].TOTAL) * 100) : 0;
                            loc.contract[year].RATE_GROWTH =
                                loc.contract[year - 1].TOTAL > 0 ? Math.ceil(((loc.contract[year].TOTAL - loc.contract[year - 1].TOTAL) / loc.contract[year - 1].TOTAL) * 100) : 0;
                        }
                    }
                });
                loc_infos.forEach((loc) => {
                    if (loc.contract) {
                        loc.contract[year].TOTAL_ALL = total;
                        loc.contract[year].RATE_SHARE = total > 0 ? ((loc.contract[year].TOTAL / total) * 100).toFixed(2) : 0;
                    }
                });
            }

            this.calculateCountryTotalData(this.state.gis_data.length, loc_infos);

            this.state.branch_infos = branch_infos;
            this.state.loc_infos = loc_infos;

            this.updateUI();
        }
    }

    calculateCountryTotalData(total_loc_count, loc_infos) {
        var country_total = {};
        for (var year = 2017; year <= new Date().getFullYear(); year++) {
            var year_total = {
                // 계약(원) 기준
                locale_count: 0,
                locale_total_count: 0,
                locale_rate: 0,
                total_count: 0,
                total_total_count: 0,
                total_rate: 0,
                nursery_count: 0,
                nursery_total_count: 0,
                nursery_rate: 0,
                daycare_count: 0,
                daycare_total_count: 0,
                daycare_rate: 0,
                null_count: 0,
                // 계약(건) 기준
                contract_total: 0,
            };
            loc_infos.forEach((loc) => {
                if (loc.contract !== undefined) {
                    year_total.nursery_count += loc.contract[year].NURSERY_NURSERY;
                    year_total.nursery_total_count += loc.NURSERY_COUNT;
                    year_total.daycare_count += loc.contract[year].NURSERY_DAYCARE;
                    year_total.daycare_total_count += loc.DAYCARE_COUNT;
                    year_total.null_count += loc.contract[year].NURSERY_NULL;
                    year_total.contract_total += loc.contract[year].TOTAL;

                    if (
                        loc.contract[year].NURSERY_NEW > 0 ||
                        loc.contract[year].NURSERY_RENEW > 0 ||
                        loc.contract[year].DAYCARE_NEW > 0 ||
                        loc.contract[year].DAYCARE_RENEW > 0 ||
                        loc.contract[year].NULL_NEW > 0 ||
                        loc.contract[year].NULL_RENEW > 0
                    ) {
                        // 계약이 있는 지역 총 숫자 증가
                        year_total.locale_count++;
                    }
                }
            });

            year_total.locale_total_count = total_loc_count;
            year_total.locale_rate = year_total.locale_total_count > 0 ? ((year_total.locale_count / year_total.locale_total_count) * 100).toFixed(2) : 0;

            year_total.total_count = year_total.nursery_count + year_total.daycare_count + year_total.null_count;
            year_total.total_total_count = year_total.nursery_total_count + year_total.daycare_total_count;
            year_total.total_rate = year_total.total_total_count > 0 ? ((year_total.total_count / year_total.total_total_count) * 100).toFixed(2) : 0;

            year_total.nursery_rate = year_total.nursery_total_count > 0 ? ((year_total.nursery_count / year_total.nursery_total_count) * 100).toFixed(2) : 0;
            year_total.daycare_rate = year_total.daycare_total_count > 0 ? ((year_total.daycare_count / year_total.daycare_total_count) * 100).toFixed(2) : 0;

            country_total[year] = year_total;
        }

        // 전국 계약 정보 갱신
        this.setState({ country_total: country_total });
    }

    initKakaoMap() {
        let container = document.getElementById("map");

        let kakaoMapOptions = {
            center: new kakao.maps.LatLng(35.74, 127.750822), //지도의 중심좌표.
            level: 13,
        };

        this.state.map = new window.kakao.maps.Map(container, kakaoMapOptions);

        // 지도 확대 축소를 제어할 수 있는  줌 컨트롤을 생성합니다
        var zoomControl = new kakao.maps.ZoomControl();
        this.state.map.addControl(zoomControl, kakao.maps.ControlPosition.BOTTOMRIGHT);
    }

    addKakaoMapLevelListener() {
        var map = this.state.map;

        kakao.maps.event.addListener(map, "zoom_changed", () => {
            var level = map.getLevel();
            if (level < 13) {
                this.state.localeNameOverlays.map((localeNameOverlay) => {
                    //localeNameOverlay.setMap(map)
                    $(".span-locale-name").show();
                });
            } else {
                this.state.localeNameOverlays.map((localeNameOverlay) => {
                    //localeNameOverlay.setMap(null)
                    $(".span-locale-name").hide();
                });
            }
        });
        $(".span-locale-name").hide();
    }

    clearKakaoMapObject() {
        // clear map polygon
        this.state.polygons.forEach((polygon) => {
            polygon.setMap(null);
        });
        this.state.polygons = [];

        // clear overlay
        this.state.localeNameOverlays.forEach((overlay) => {
            overlay.setMap(null);
        });
        this.state.localeNameOverlays = [];
    }

    updateUI() {
        this.clearKakaoMapObject();

        this.initKakaoMap();

        var init_locale_branch_select = { COUNT: 0, CODE: 0 };

        this.state.gis_data.forEach((sigungu) => {
            var loc_info = this.state.loc_infos.find((loc_code) => loc_code.CODE == sigungu.properties.SIG_CD);

            if (loc_info && loc_info.contract[this.state.year].TOTAL > 0) {
                if (init_locale_branch_select.COUNT < loc_info.contract[this.state.year].TOTAL) {
                    init_locale_branch_select.COUNT = loc_info.contract[this.state.year].TOTAL;
                    init_locale_branch_select.CODE = loc_info.CODE;
                }
                this.displayArea(this, sigungu.geometry.coordinates, loc_info, loc_info.contract[this.state.year].TOTAL);
            }
        });

        this.addKakaoMapLevelListener();

        this.initLocaleSelectInfo(init_locale_branch_select);
    }

    displayArea(parent, coordinates, loc_info, count) {
        var paths = [];

        var depth = -1;
        var color = "";
        var hasNotBizareaBranch = false;
        if (this.state.display_method == BY_BRANCH && loc_info.bizs != null && loc_info.bizs.length > 0) {
            var NotBizareaBranches = loc_info.bizs.filter((biz) => biz.is_biz_area == false);
            if (NotBizareaBranches.length > 0) {
                hasNotBizareaBranch = true;
            }
        }

        if (this.state.display_method === BY_ABSOLUTE) {
            depth = Math.floor(count / 10);
        } else if (this.state.display_method === BY_RELATIVE) {
            depth = loc_info.contract[this.state.year].RATE_LOCALE;
            if (depth > -1) depth = Math.floor(depth / 3);
        } else {
            depth = loc_info.contract[this.state.year].BRANCH - 1;
        }

        if (depth === -1) {
            color = "#555555";
        } else {
            if (depth >= ACC_COLOR_TABLE.length) depth = ACC_COLOR_TABLE.length - 1;
            if (this.state.display_method === BY_BRANCH) color = BRANCH_ACC_COLOR_TABLE[depth];
            else color = ACC_COLOR_TABLE[depth];
        }

        loc_info.DEPTH = depth;
        loc_info.DEPTH_COLOR = color;

        coordinates.forEach((innercoordinates) => {
            var path = [];

            innercoordinates.forEach((coordinate) => {
                path.push(new kakao.maps.LatLng(coordinate[1], coordinate[0]));
            });

            paths.push(path);
        });

        var polygon = new kakao.maps.Polygon({
            map: this.state.map,
            path: paths,
            strokeWeight: 1,
            strokeColor: STROKE_COLOR_MAP,
            strokeOpacity: 0.6,
            fillColor: color,
            fillOpacity: 0.9,
            zIndex: 9,
        });

        var center = centeroid(paths.find((path) => path !== null && path.length > 0));

        var content = document.createElement("div");
        content.innerHTML = !hasNotBizareaBranch
            ? '<span class="span-locale-name" style="display:block;color:#444444">' + loc_info.NAME + "</span>"
            : '<span><i class="fa fa-flag" style="color:#cb0504;font-size:10px" aria-hidden="true"></i>' +
              '<span class="span-locale-name" style="display:none;color:#444444">' +
              loc_info.NAME +
              "</span></span>";
        //content.innerHTML = loc_info.NAME;

        var localeNameOverlay = new kakao.maps.CustomOverlay({
            position: center,
            content: content,
            clickable: false,
            map: this.state.map,
        });

        // 커스텀 오버레이를 지도에 표시합니다
        //localeNameOverlay.setMap(this.state.map);

        var mouseOverHandler = function () {
            polygon.setOptions({ strokeWeight: 3, strokeColor: parent.state.stroke_color, strokeOpacity: 1, zIndex: 10 });
            if (parent.state.selected_polygon === null) {
                parent.displayInfo(parent, polygon, loc_info);
            }
        };
        var mouseOutHandler = function () {
            if (parent.state.selected_polygon === null) {
                parent.setShowInfoState(false);
            }
            if (parent.state.selected_polygon === null || parent.state.selected_loc.CODE != loc_info.CODE) {
                polygon.setOptions({ strokeWeight: 1, strokeColor: STROKE_COLOR_MAP, strokeOpacity: 0.6, zIndex: 9 });
                //polygon.setOptions({ fillColor: loc_info.DEPTH_COLOR });
            }
        };
        var mouseClickHandler = function () {
            if (parent.state.selected_polygon != null) {
                //parent.state.selected_polygon.setOptions({ fillColor: parent.state.selected_polygon_color });
                parent.state.selected_polygon.setOptions({ strokeWeight: 1, strokeColor: STROKE_COLOR_MAP, strokeOpacity: 0.6, zIndex: 9 });
            }
            //polygon.setOptions({fillColor: STROKE_COLOR_MAP_HIGHLIGHTED});
            parent.onMapLocaleSelect(loc_info, polygon, loc_info.DEPTH_COLOR);
            parent.displayInfo(parent, polygon, loc_info);
        };

        kakao.maps.event.addListener(polygon, "mouseover", mouseOverHandler);
        kakao.maps.event.addListener(polygon, "click", mouseClickHandler);
        kakao.maps.event.addListener(polygon, "mouseout", mouseOutHandler);
        content.addEventListener("mouseover", mouseOverHandler);
        content.addEventListener("click", mouseClickHandler);
        content.addEventListener("mouseout", mouseOutHandler);

        parent.state.polygons.push(polygon);
        parent.state.localeNameOverlays.push(localeNameOverlay);

        function centeroid(points) {
            var i, j, len, p1, p2, f, area, x, y;

            area = x = y = 0;

            for (i = 0, len = points.length, j = len - 1; i < len; j = i++) {
                p1 = points[i];
                p2 = points[j];

                f = p1.Ga * p2.Ha - p2.Ga * p1.Ha;
                x += (p1.Ha + p2.Ha) * f;
                y += (p1.Ga + p2.Ga) * f;
                area += f * 3;
            }

            return new kakao.maps.LatLng(x / area, y / area);
        }
    }

    displayInfo(parent, polygon, loc_info) {
        var name = (loc_info.PARENT_NAME_SIDO ? loc_info.PARENT_NAME_SIDO + " " + (loc_info.PARENT_NAME_SIGUNGU ? loc_info.PARENT_NAME_SIGUNGU + " " : "") : "") + loc_info.NAME;
        var content = null;
        parent.setShowInfoState(true, name, content);
    }

    onYearChange = (e) => {
        const value = e.target.value;
        this.setState(
            {
                year: value,
            },
            () => {
                this.updateUI();
            }
        );
    };

    onDisplayMethodChange = (e) => {
        const value = e.target.value;
        this.setState(
            {
                display_method: value,
                stroke_color: value === BY_BRANCH ? STROKE_COLOR_MAP_HIGHLIGHTED_BRANCH : STROKE_COLOR_MAP_HIGHLIGHTED,
            },
            () => {
                this.updateUI();
            }
        );
    };

    onLocaleBranchSelectHandler = (branch) => {
        this.setState({ is_branch_select: true, selected_branch: branch, selected_for_graph: branch });
    };

    onBranchBizareaSelectHandler = (loc) => {
        this.setState({ is_branch_select: false, selected_for_graph: loc });
    };

    onBranchSelectHandler = (branch) => {
        console.debug(branch);
    };

    onLocaleSelectHandler = (loc_info) => {};

    onMapLocaleSelect = (loc_info, polygon, polygon_color) => {
        if (loc_info.bizs !== null && loc_info.bizs.length > 0) {
            if (this.state.selected_polygon === null || (this.state.selected_loc !== null && this.state.selected_loc.CODE !== loc_info.CODE)) {
                this.setState({
                    is_branch_select: false,
                    selected_loc: loc_info,
                    selected_branch: loc_info.contract[this.state.year].TOTAL > 0 ? loc_info.bizs[0].branch : null,
                    selected_for_graph: loc_info,
                    selected_polygon: polygon,
                    selected_polygon_color: polygon_color,
                });
            } else {
                this.state.selected_polygon = null;
                this.state.selected_polygon = null;
            }
        } else this.setState({ is_branch_select: false, selected_loc: loc_info, selected_branch: null, selected_for_graph: loc_info });
    };

    setShowInfoState = (isShow, title, content) => {
        this.setState({ showInfo: isShow, title: title, content: content });
    };

    initLocaleSelectInfo = (loc_info) => {
        var init_locale = this.state.loc_infos.find((l) => l.CODE == loc_info.CODE);
        if (init_locale) {
            this.setState({
                is_branch_select: false,
                selected_loc: init_locale,
                selected_branch: init_locale.bizs && init_locale.bizs.length > 0 ? init_locale.bizs[0].branch : null,
                selected_for_graph: init_locale,
            });
        }
    };

    renderLegend() {
        var lis = [];
        if (this.state.display_method === BY_ABSOLUTE) {
            lis.push(
                <li key={"legend-li-main"} className="list-group-item text-center align-middle">
                    계약
                </li>
            );
            for (var i = ACC_COLOR_TABLE.length - 1; i > -1; i--) {
                var txt = "" + (i + 1) * 10;
                if (i === ACC_COLOR_TABLE.length - 1) txt += "+";
                lis.push(
                    <li key={"legend-li-" + i} className="list-group-item" style={{ backgroundColor: ACC_COLOR_TABLE[i] }}>
                        {txt}
                    </li>
                );
            }

            return (
                <ul className="list-group" style={{ width: "30px" }}>
                    {lis}
                </ul>
            );
        } else if (this.state.display_method === BY_RELATIVE) {
            lis.push(
                <li key={"legend-li-main"} className="list-group-item text-center align-middle">
                    점유(%)
                </li>
            );
            for (var i = ACC_COLOR_TABLE.length - 1; i > -1; i--) {
                var txt = "" + (i + 1) * 3;
                if (i === ACC_COLOR_TABLE.length - 1) txt += "+";
                lis.push(
                    <li key={"legend-li-" + i} className="list-group-item" style={{ backgroundColor: ACC_COLOR_TABLE[i] }}>
                        {txt}
                    </li>
                );
            }

            return <ul className="list-group">{lis}</ul>;
        } else {
            lis.push(
                <li key={"legend-li-main"} className="list-group-item text-center align-middle">
                    지사
                </li>
            );
            for (var i = BRANCH_ACC_COLOR_TABLE.length - 1; i > -1; i--) {
                var txt = "" + (i + 1);
                if (i === BRANCH_ACC_COLOR_TABLE.length - 1) txt += "+";
                lis.push(
                    <li key={"legend-li-" + i} className="list-group-item" style={{ backgroundColor: BRANCH_ACC_COLOR_TABLE[i] }}>
                        {txt}
                    </li>
                );
            }

            return (
                <ul className="list-group" style={{ width: "30px" }}>
                    {lis}
                </ul>
            );
        }
    }

    render() {
        var yearList = [];
        var currentYear = new Date().getFullYear();
        for (var year = currentYear; year > 2017; year--) {
            yearList.push(<option key={"option-year-" + year}>{year}</option>);
        }
        var mapDesc = "* ";
        if (this.state.display_method === BY_ABSOLUTE) {
            mapDesc += "지역내 가입 계약건(전체 계약 대비)";
        } else if (this.state.display_method === BY_RELATIVE) {
            mapDesc += "지역내 계약 점유율(전체 계약 대비)";
        } else {
            mapDesc += "지역내 중첩 지사";
        }

        return (
            <div className="dashboard-wrapper">
                <div className="container-fluid dashboard-content bg-white box-shadow-down pb-2">
                    <div className="row">
                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                            <div className="page-header">
                                <h2 className="pageheader-title">계약 - 지역</h2>
                            </div>
                        </div>
                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 text-right">
                            <div className="row">
                                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 text-right">
                                    <select className="form-control" defaultValue={currentYear} onChange={this.onYearChange} style={{ fontSize: "1.1em" }}>
                                        {yearList}
                                    </select>
                                </div>
                                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 text-right">
                                    <select className="form-control" onChange={this.onDisplayMethodChange} style={{ fontSize: "1.1em" }}>
                                        <option value={BY_ABSOLUTE}>전국 점유율 분포</option>
                                        <option value={BY_RELATIVE}>지역내 점유율 분포</option>
                                        <option value={BY_BRANCH}>지사 중첩 분포</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container-fluid dashboard-content">
                    <div className="row">
                        <MapContractCards year={this.state.year} data={this.state.country_total} />
                    </div>

                    <div className="row">
                        <div className="col-xl-7 col-lg-7 col-md-7 col-sm-12 col-12">
                            <div className="card border-top border-3 border-top-primary">
                                <div className="card-body" style={{ padding: "10px" }}>
                                    <div className="text-right" style={{ height: "20px", marginTop: "-5px" }}>
                                        <h6 className="card-header-title text-muted">{mapDesc}</h6>
                                    </div>
                                    <div>
                                        <div className="map-container">
                                            <KakaoMapContent
                                                parent={this}
                                                height={HEIGHT_KAKAO_MAP - 35}
                                                onKakaoScriptLoadEnd={this.onKakaoScriptLoadEndHandler}
                                                style={{ fontSize: "10px" }}
                                            ></KakaoMapContent>
                                            <div className={`wrap${this.state.showInfo ? " show" : " d-none"}`} style={{ marginTop: "5px", width: "180px" }}>
                                                <div className="info border-top border-3 border-top-warning" style={{ width: "178px" }}>
                                                    <div className="title">{this.state.title}</div>
                                                </div>
                                            </div>
                                            <div className="map_legend" style={{ marginTop: "15px" }}>
                                                {this.renderLegend()}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-5 col-lg-5 col-md-5 col-sm-12 col-12">
                            <LocaleBranchList
                                year={this.state.year}
                                loc_info={this.state.selected_loc}
                                branch={this.state.selected_branch}
                                height={(HEIGHT_KAKAO_MAP - 40) / 2}
                                onLocaleBranchSelectHandler={this.onLocaleBranchSelectHandler}
                            ></LocaleBranchList>
                            <BranchBizareaInfo
                                year={this.state.year}
                                branch={this.state.selected_branch}
                                loc_info={this.state.selected_loc}
                                loc_infos={this.state.loc_infos}
                                height={(HEIGHT_KAKAO_MAP - 40) / 2 + 13}
                                onBranchBizareaSelectHandler={this.onBranchBizareaSelectHandler}
                            ></BranchBizareaInfo>
                        </div>
                    </div>

                    {/* <div className="row">
                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                            <ContractNurseryChart year={this.state.year} height={300} data={this.state.country_total} yearChangeHandler={this.onYearChange} />
                        </div>
                    </div> */}
                    <div className="row">
                        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                            <LocaleList
                                year={this.state.year}
                                loc_infos={this.state.loc_infos != null && this.state.loc_infos.length > 0 ? this.state.loc_infos.filter((loc) => loc["gis_data"] != null) : null}
                                selected_loc={this.state.selected_loc}
                                country_total={this.state.country_total}
                                height="400"
                                onLocaleSelectHandler={this.onLocaleSelectHandler}
                            ></LocaleList>
                        </div>
                    </div>

                    {/* <div className="row">
                        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                            <BranchList branchList={this.state.branch_infos} selected_branch={this.state.selected_branch} height="400" onBranchSelectHandler={this.onBranchSelectHandler}></BranchList>
                        </div>
                    </div> */}
                </div>
            </div>
        );
    }
}

export default MapContract;
